/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import './css/PricingPlan.css'
import Fcontact from '../Shared/Fcontact';
import { Helmet } from 'react-helmet';
import Aos from 'aos';
import Modal from "react-bootstrap/Modal";
import ppBannerImg from "../../assets/imgs/pricing-banner.webp"
import RcSubscription from "../../assets/imgs/subscription-img.webp"
import RcPackageTerms from "../../assets/imgs/tems-packages.webp"
import PaidO from "../../assets/imgs/paid_o.png"
import Config from "../../assets/imgs/config.png"
import PaidG from "../../assets/imgs/paid_g.png"





const PricingPlan = () => {
    const [isFormLoaded, isSetFormLoaded] = useState(false);
    const [show, setShow] = useState(false);
    const [policy, setPolicy] = useState(false);
    const handleClose = () => {
        setPolicy(false);
        setShow(false);
      };
    const handleShow = () => {
        setPolicy(true);
        setShow(true);
      };
    useEffect(() => {
        window.addEventListener('load', Aos.refresh);
        isSetFormLoaded(true);

        Aos.init({
            once: false
        })
    });
    
    useEffect(() => {
        const violation = document.getElementById("top-menu");
        window.scrollTo({
            top: violation.offsetTop,
            // behavior: "smooth",
        });
    }, []);
    
     return (
        <>
            <Helmet>
                 <title>Right Cause CRM Pricing: Choose the Perfect Plan for Your Nonprofit</title>
                <meta name="keywords" content="" />
                 <meta name="description" content="Discover the full potential of your nonprofit with Right Cause's 
                 pricing plans. Our all-in-one CRM software is affordably priced to suit 
                 any budget while maximizing your impact." />
            </Helmet>
            <header>
                <div class="container-fluid">
                    <div class="banner-wrap">
                        <div class="banner-slider">
                            <div class="banner-slide g-banner">
                                <div class="container">
                                    <div class="sliderContent">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="slideTxt">
                                                    <div class="darkTxt g-darkTxt">Right Cause<br/>Nonprofit CRM 
                                                    </div>
                                                    <p>The most robust, secure and affordable CRM Solution for Fundraising, Donation and Grants Management.</p>
                                                    
                                                    <div class="homesliderbtn"> <a href="#getStrated" class="rc-primary-btn rc-large-btn rc-btn"
                                                            tabindex="0" aria-label="Get a Demo Button">Get started for free <i class="icon-arrow"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="g-mask">
                                                    <img class="svg-normal-mask" alt="A Cloud-based charity-focused Nonprofit Software" src={ppBannerImg} width="1000" height="667" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <section class="acceleratorCrm-Section">
                    <div class="container">
                        <div class="row align-items-center text-center">
                            <div class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3 mb-5" data-aos="zoom-in">
                                <p>Right Cause is Nonprofit CRM suite built on secure Microsoft Cloud which comes with end-to-end non-profit focus. Get charity-specific features that will improve the way you engage with existing and potential donors. Track all activities related to Fundraising, Volunteers, Grant Management and beyond.</p>
                            </div>
                            <div class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3" data-aos="zoom-in">
                                <h1 class="h1">Right Cause - Enterprise CRM Pricing</h1>
                                <p>We offer five comprehensive packages designed to meet the needs of nonprofits of all sizes:</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3" data-aos="zoom-in">
                                <div class="text-center"><strong> Pricing Plans</strong> </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-8 text-center mx-auto mt-5">
                                <div class="ent-pricing">
                                    <div class="ent-pricing-header">
                                        <h2>Right Cause- Enterprise</h2>
                                        <div class="ent-amnt"><sup>$</sup>59<sup>*</sup></div>
                                        <p>USD/User/Month</p>
                                        <small>(Billed Annually) </small>
                                    </div>
                                    <div class="col-md-12 text-center col-cstm">
                                        <div class="row mt-4 mx-0">
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-charity"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Fundraising
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-pledge"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Grants & Pledges
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-Donations"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Donations
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-Volunteer"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Volunteers
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-Membership"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Membership
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4 d-flex align-items-center">
                                                <div class="icon-b">
                                                    <i class="icon-Integrations"></i>
                                                </div>
                                                <div class="icons-b-text">
                                                    Integrations
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <section class="addons-Section">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 mt-xs-3" data-aos="zoom-in">
                                <div class="table-responsive pricingTbl packages">
                                    <table class="table">
                                        <thead class="table-light">
                                            <tr>
                                                <th scope="col" width="250">&nbsp;

                                                </th>
                                                <th scope="col" width="250" class="text-center">Per Unit Price/Year

                                                </th>
                                                <th scope="col" width="250" class="text-center">Per Unit Price/Month (Available for
                                                    Annual Commitment only)

                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colspan="3" class="p-2"></td>
                                            </tr>
                                            <tr>
                                                <td>Right Cause - CRM Enterprise Suite</td>
                                                <td class="text-center">$708*</td>
                                                <td class="text-center">$59*</td>

                                            </tr>
                                            <tr>
                                                <td>Right Cause - Fundraising Portal</td>
                                                <td class="text-center">$770*</td>
                                                <td class="text-center">$65*</td>

                                            </tr>
                                            <tr>
                                                <td>Right Cause - Membership Portal</td>
                                                <td class="text-center">$770*</td>
                                                <td class="text-center">$65*</td>

                                            </tr>
                                            <tr>
                                                <td>Right Cause - Volunteer Portal</td>
                                                <td class="text-center">$770*</td>
                                                <td class="text-center">$65*</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="subscription">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-6 aos-animate" data-aos="fade-right">
                                <h3 class="h1">Each Right Cause Subscription Includes
                                </h3>
                                <ul>
                                    <li>10GB/Tenant Dynamics 365 Storage</li>
                                    <li>1TB/Organization Sharepoint Storage</li>
                                    <li>Single Dynamics 365 Account per user that will be used as service account as admin</li>
                                </ul>
                                <div class="notes-b">
                                    <strong>
                                        Notes:
                                    </strong>
                                    <ul>
                                        <li>For more than one user, additional Dynamics 365 licenses need to be purchased at your
                                            end.
                                        </li>
                                        <li>Needs One Drive for service account </li>
                                        <li>The Addon portals pricing includes 100 authenticated users/month</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <img alt="Each Right Cause Subscription Includes" src={RcSubscription} width="624" height="546" class="img-fluid" />
                            </div>
                        </div>
                    </div>
                </section>

                <section class="paymentMethods">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 mb-5 mt-5 text-center">
                                <h3 class="h1">
                                    Access all the Charity-specific features
                                </h3>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltBlue">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Grants-Management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Grants Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpurple">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Donation-Management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Donation Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltGreen">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Volunteer"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Volunteer Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpeach">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Contact-Management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Contact Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltBlue">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Project-management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Program and Project management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpurple">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Membership"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Membership Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltGreen">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-charity"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Fundraising Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpeach">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Events-Management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Event Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltBlue">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-task-management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Activity & Task Management</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpurple">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-wealth-management"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Wealth Screening</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltGreen">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-Reports"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Reporting & Analytics</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-3 mb-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpeach">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-buttergive"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Give Butter Integration</h5>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="row">
                            <div class="col-md-12 mb-5 mt-5 text-center aos-animate" data-aos="fade-up">
                                <h3 class="h1">
                                    In-built Integrations
                                </h3>
                            </div>
                            <div class="col-md-4 col-lg-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltBlue">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-ms-teams"></i>
                                    </div>
                                    <div class="card-body">

                                        <h5 class="card-title">MS Teams</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltpurple">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-outlooks"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">Outlook</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4 text-center aos-animate" data-aos="fade-up">
                                <div class="card ltGreen">
                                    <div class="paymentMethods_icon">
                                        <i class="icon-sharpoint"></i>
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title">SharePoint</h5>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                
                <section class="Integrations-Section">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3" data-aos="zoom-in">
                                <div class="table-responsive pricingTbl mt-5">
                                    <table class="table">
                                        <thead class="table-light">
                                            <tr>
                                                <th scope="col" width="250">Supported - Integrations
                                                    <hr />
                                                </th>
                                                <th scope="col" width="250">Remarks
                                                    <hr />
                                                </th>
                                                <th scope="col" width="250">Pre-Requisite
                                                    <hr />
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Zapier</td>
                                                <td align="center"><img alt="subscription" src={PaidO} width="34" height="34" class="img-fluid" /> Paid/On Demand</td>
                                                <td>Zapier subscription</td>
                                            </tr>
                                            <tr>
                                                <td>MailChimp</td>
                                                <td><img alt="subscription" src={PaidO} width="34" height="34" class="img-fluid" /> Paid/On Demand</td>
                                                <td>Intuit Connector</td>
                                            </tr>
                                            <tr>
                                                <td>Quick Books</td>
                                                <td><img alt="subscription" src={PaidO} width="34" height="34" class="img-fluid" /> Paid/On Demand</td>
                                                <td>Intuit Connector</td>
                                            </tr>
                                            <tr>
                                                <td>Give Butter</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Give Butter Account</td>
                                            </tr>
                                            <tr>
                                                <td>Paypal</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Paypal Account</td>
                                            </tr>
                                            <tr>
                                                <td>Stripe</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Stripe Account</td>
                                            </tr>
                                            <tr>
                                                <td>RazorPay</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>RazorPay Account</td>
                                            </tr>
                                            <tr>
                                                <td>Facebook</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Facebook Account</td>
                                            </tr>
                                            <tr>
                                                <td>Instagram</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Instagram Account</td>
                                            </tr>
                                            <tr>
                                                <td>Twitter/X</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Twitter/X Account</td>
                                            </tr>
                                            <tr>
                                                <td>LinkedIn</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>LinkedIn Account</td>
                                            </tr>
                                            <tr>
                                                <td>Merchant Warrior</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>Merchant Warrior Account</td>
                                            </tr>
                                            <tr>
                                                <td>MS Teams</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>MS Teams Account</td>
                                            </tr>
                                            <tr>
                                                <td>MS Sharepoint</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>MS Sharepoint Account</td>
                                            </tr>
                                            <tr>
                                                <td>MS Planner</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>MS Planner Account</td>
                                            </tr>
                                            <tr>
                                                <td>MS Outlook</td>
                                                <td><img alt="Configurable" src={Config} width="34" height="34" class="img-fluid" /> Configurable</td>
                                                <td>MS Outlook Account</td>
                                            </tr>
                                            <tr>
                                                <td>Canvas Apps</td>
                                                <td><img alt="Demand" src={PaidG} width="34" height="34" class="img-fluid" /> On Demand</td>
                                                <td>Power Apps subscription</td>
                                            </tr>
                                            <tr>
                                                <td>Omnichannels and External WebSites</td>
                                                <td><img alt="Demand" src={PaidG} width="34" height="34" class="img-fluid" /> On Demand/Paid </td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Power Virtual Agent (PVA)</td>
                                                <td><img alt="Demand" src={PaidG} width="34" height="34" class="img-fluid" /> On Demand/Paid </td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="terms">
                    <div class="container">
                        <div class="row align-items-center">
                                <div class="col-md-6 col-lg-6 aos-animate" data-aos="fade-right">
                                <h5 class="h1 mb-5">Package Terms</h5>
                                <ul>
                                    <li>7- day free Trial can only be implemented by the Right Cause team</li>
                                    <li>$59/user pricing can only be availed for annual commitment, not for monthly subscription.
                                    </li>
                                    <li>The support for Right Cause will be valid once the application goes live on production. </li>
                                    <li>Included in the package are minor bug fixes, enhancements that do not require extensive development,
                                        recommendations on updates as per Microsoft, and issues that arise in the application and
                                        are not due to infrastructure/product limitations. </li>
                                    <li>Resolution time will depend on the nature of the issue/bug reported. </li>
                                    <li>Response & resolution will be done in 1-3 business days depending on the criticality of the
                                        issues.
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6">
                            <img class="img-fluid" alt="Package Terms" src={RcPackageTerms} width="612" height="613" />
                            </div>
                        </div>
                    </div>
                </section>

                <section class="faqs">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center mb-4">
                                <h5 class="h1">FAQs</h5>
                            </div>
                            <div class="col-md-12">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                            <strong>  Does Right Cause charge a transaction fee?</strong>
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                Charities can save thousands of dollars annually with the lowest processing fees available. Right Cause can be integrated
                                                with your existing payment system like Paypal and Stripe to process donations which
                                                each have a nonprofit rate of 2.2% + 30 cents. Right Cause does NOT take anything
                                                on top of these fees. </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                                                aria-controls="collapseTwo">
                                            <strong> Where does Right Cause store my data? </strong>
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                    Our data is stored in the United States, Canada or Australia depending on where your nonprofit is based in (USA, CAD, AUS only). Right Cause data is stored on Microsoft Azure servers.  
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                                                aria-controls="collapseThree">
                                                <strong> Does Right Cause offer customer support? </strong>
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                    Yes, Right Cause offer support on email. 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <div>
                
                
                <Modal size="lg" show={show} onHide={handleClose} className="modal_getStartedForm">
                    <Modal.Header closeButton></Modal.Header>
                    <Fcontact policy={policy} onSubmit={handleClose} />
                </Modal>
            </div>
        </>
         
     )
}

export default PricingPlan;